import { AdminTableComponent } from './admin-table.component';
import { AdminSortHeaderComponent } from './sort-header.component';
import {
  AdminTableEmptyDirective,
  AdminTableHeaderDirective,
  AdminTableRowDirective,
} from './table-templates.directive';

export * from './admin-table.component';
export * from './paginator.component';
export * from './sort-header.component';
export * from './table-templates.directive';
export * from './table.util';

/** Everything a template needs for an admin table: `imports: [...ADMIN_TABLE_IMPORTS]`. */
export const ADMIN_TABLE_IMPORTS = [
  AdminTableComponent,
  AdminTableHeaderDirective,
  AdminTableRowDirective,
  AdminTableEmptyDirective,
  AdminSortHeaderComponent,
] as const;
